import request from '@/utils/request'

let RankApi = {
    /*获取数据*/
    getSetting(data) {
        return request._get('/shop/plus.rank.Rank/getSetting', data);
    },
    setSetting(data) {
        return request._post('/shop/plus.rank.Rank/setSetting', data);
    },
    queryRedpageRank(data) {
        return request._post('/shop/plus.rank.Rank/queryRedpageRank', data);
    },
    queryFansRank(data) {
        return request._post('/shop/plus.rank.Rank/queryFanRank', data);
    }


}
export default RankApi;



// WEBPACK FOOTER //
// ./src/api/rank.js